<script setup lang="ts">
/**
 * Share Certificate — M32205 (standalone).
 * Transfer TransferShareCertDoc 화면을 단독 문서로 이식.
 * · 변수: cert_no / no_of_shares / member_name / shares_* / share_class /
 *         company_name / company_registration_no / registered_office_address / issue_date / [[Signers]]
 */
import ShareCertDocVarField from './ShareCertDocVarField.vue';
import ShareCertSigners from './parts/ShareCertSigners.vue';
import ShareCertCertificateNoField from './parts/ShareCertCertificateNoField.vue';
</script>

<template>
  <div class="allot-doc sc-cert">
    <table class="sc-top">
      <tbody>
        <tr>
          <td class="sc-topcell"><div class="sc-toplbl">Certificate No.</div><ShareCertCertificateNoField /></td>
          <td class="sc-topcell"><div class="sc-toplbl">No. of Shares</div><ShareCertDocVarField field-key="no_of_shares" /></td>
        </tr>
      </tbody>
    </table>

    <div class="sc-head">
      <div class="doc-company"><ShareCertDocVarField field-key="company_name" /></div>
      <div class="doc-meta">(the "Company") (Company Registration No. <ShareCertDocVarField field-key="company_registration_no" />)</div>
      <div class="doc-meta italic">Incorporated in Malaysia under the Companies Act 2016</div>
      <div class="doc-meta">REGISTERED OFFICE: <ShareCertDocVarField field-key="registered_office_address" /></div>
    </div>

    <p class="doc-p sc-body">
      This is to certify that <ShareCertDocVarField field-key="member_name" /> is the Registered Holder of
      <ShareCertDocVarField field-key="shares_numeral" /> (<ShareCertDocVarField field-key="shares_words" />)
      <ShareCertDocVarField field-key="share_class" /> Shares fully paid in <ShareCertDocVarField field-key="company_name" />
      subject to the Constitution of the Company.
    </p>

    <p class="doc-p">Issued by the Company on <ShareCertDocVarField field-key="issue_date" />.</p>

    <div class="sc-signers">
      <ShareCertSigners
        var-key="share_cert"
        board-label="Given under the Common Seal / by the Director and Secretary of the Company"
      />
    </div>

    <p class="doc-attn">
      NOTE: No transfer of any portion of the shares comprised in this Certificate will be registered unless accompanied by this Certificate.
    </p>
  </div>
</template>

<style src="../transfer/transferDoc.css"></style>
<style scoped>
.sc-cert { border: 3px double #7a6a3a; padding: 20px 24px; background: #fffdf7; min-height: 240mm; }
.sc-top { width: 100%; border-collapse: collapse; margin-bottom: 14px; }
.sc-topcell { width: 50%; border: 1px solid #b8ac86; padding: 6px 10px; vertical-align: top; }
.sc-toplbl { font-size: 10px; font-weight: 700; color: #7a6a3a; margin-bottom: 2px; }
.sc-head { text-align: center; margin: 8px 0 16px; }
.sc-head .doc-company { font-size: 18px; font-weight: 800; letter-spacing: .03em; }
.sc-head .doc-meta { font-size: 11px; color: #333; margin-top: 2px; }
.sc-head .doc-meta.italic { font-style: italic; }
.sc-body { line-height: 2; }
.sc-signers { margin-top: 26px; }
</style>
